import CollapsibleSection from './components/CollapsibleSection';
import './scss/Equipment.scss';

function Equipment({ equipment }) {

  return (
    <CollapsibleSection 
      id="equipment" 
      name="Key equipment"
      defaultCollapsed={true}
      expandedOnDesktop={true}
    >
      <div className="section-content">
        {equipment.map((item, index) =>
          <div className="item" key={index}>
            <img className="item-image" src={item.img} />
            <p className="item-name">{item.name}</p>
            {item.note && <p className="item-note">{item.note}</p>}
          </div>
        )}
      </div>
      <div className="supplemental-bottom-border"></div>
    </CollapsibleSection>
  );
}

export default Equipment;